import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Home from "./pages/Home/Home";
import Booking from "./pages/Booking/Booking";
import Shop from "./pages/Shop/Shop";
import Contact from "./pages/Contact/Contact";
import Audio from "./pages/Audio/Audio";
import Pricing from "./pages/Pricing/Pricing";
import ScrollToTop from "./components/ScrollToTop"; // ⬅️ added

const App = () => {
  return (
    <Router>
      <Navbar />
      <ScrollToTop /> {/* ⬅️ added */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/audio" element={<Audio />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
};

export default App;
